import { SUPPORTED_LOCALES, SupportedLocale } from './window.types';

const reloadPage = (): void => {
  window.location.reload();
};

const loadPage = (path: string): void => {
  window.location.assign(path);
};

const isSupportedLocale = (value: string): value is SupportedLocale =>
  (SUPPORTED_LOCALES as readonly string[]).includes(value);

// Locale detection with no dependency on TranslationProvider/i18next, for
// contexts that must render even if the translation system itself failed
// to initialize. Checked in order: the URL's /:locale/ path segment, then
// the browser's own language setting, falling back to German.
const detectLocale = (): SupportedLocale => {
  const pathSegment = window.location.pathname.split('/')[1];
  if (pathSegment && isSupportedLocale(pathSegment)) return pathSegment;

  const browserLanguage = navigator.language?.split('-')[0];
  if (browserLanguage && isSupportedLocale(browserLanguage)) return browserLanguage;

  return 'de';
};

export { detectLocale, loadPage, reloadPage };
